import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { homeSelector, setIsJoinPopupVisible, setScrollPosition, setStatusbarColor } from "../featurs/homeSlice";

const useToggleJoinPopup = () => {
  const dispatch = useDispatch();
  const { isJoinPopupVisible, statusbarColor } = useSelector(homeSelector);
  const cache = useRef("#292929");

  function toggleHandler() {
    // `isJoinPopupVisible` is the value BEFORE this dispatch, so derive the
    // next visibility explicitly instead of re-reading the (stale) selector.
    const willBeVisible = !isJoinPopupVisible;

    if (willBeVisible) {
      // Remember the current section color so we can restore it on close.
      cache.current = statusbarColor || cache.current;
      dispatch(setScrollPosition(window.scrollY));
      dispatch(setStatusbarColor("#211F22"));
    } else {
      dispatch(setStatusbarColor(cache.current));
    }

    dispatch(setIsJoinPopupVisible());
  }
  return toggleHandler;
};

export { useToggleJoinPopup };
